import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { Breadcrumbs } from '@/components/layout/Breadcrumbs';
import { PageContainer } from '@/components/layout/PageContainer';
import { BackButton } from '@/components/composite/buttons/BackButton';
import { SquaresGameRulesTab } from '@/components/squares/SquaresGameRulesTab';

export const Route = createFileRoute('/dashboard/squares/settings')({
  validateSearch: (search: Record<string, unknown>) => {
    return {
      tab: search.tab as 'game-rules' | undefined,
    };
  },
  component: SquaresSettingsPage,
});

function SquaresSettingsPage() {
  const search = Route.useSearch();
  const navigate = useNavigate();
  const activeTab = search.tab || 'game-rules';

  return (
    <PageContainer>
      <Breadcrumbs overrides={{ squares: 'Squares', settings: 'Settings' }} />

      <div className="flex items-center gap-4 mb-6">
        <BackButton />
        <h1 className="text-2xl font-semibold">Squares Settings</h1>
      </div>

      <Tabs
        value={activeTab}
        onValueChange={value =>
          navigate({
            to: '/dashboard/squares/settings',
            search: { tab: value as 'game-rules' },
          })
        }
        className="w-full"
      >
        <TabsList className="grid w-full grid-cols-1">
          <TabsTrigger value="game-rules">Game Rules</TabsTrigger>
        </TabsList>

        <TabsContent value="game-rules" className="space-y-4">
          <SquaresGameRulesTab />
        </TabsContent>
      </Tabs>
    </PageContainer>
  );
}
